import { array, oneOfType, number, string } from 'prop-types'

const tag = string

const flexColumnGap = oneOfType([string, number, array])
const flexRowGap = oneOfType([string, number, array])

export { tag, flexRowGap, flexColumnGap }
